import React from 'react';
import { useTranslation } from 'react-i18next';
import { FloaterTooltipMarkdown, Icon } from '@honda-canada/design-system-react';
import themeStyles from '../SelectProducts/styles/DropDownSelectors.styles';

const Tooltip = themeStyles.apply(FloaterTooltipMarkdown, 'Tooltip');

const DownPaymentTooltip = () => {
  const { t } = useTranslation();
  return (
    <Tooltip
      content={t('Sub-apps.PriceAndFinance.downPaymentTooltipLabel')}
      aria-expanded="false"
      data-testid="cy-downpayment-tooltip"
    >
      {({ active }) => <Icon name="information" aria-expanded="false" filled={active} />}
    </Tooltip>
  );
};

export default DownPaymentTooltip;
